export default function createAhoyEvent(email) {
  ahoy.start();
  ahoy.track('Subscription Conversion', {
    url: window.location.pathname,
    email: email,
  })
}
